import {Module} from "vuex";
import {RootState} from "@/store/types";
import {mnStatistic} from "@/store/mailnotify/statistic";
import {mnTemplate} from "@/store/mailnotify/templates";

export const mailnotifyModule: Module<any, RootState> = {
  modules: {
    mnStatistic,
    mnTemplate,
  }
}